const STORAGE_KEY = "reduxState";

export const loadState = () => {
  try {
    const serializedState = sessionStorage.getItem(STORAGE_KEY); // use sessionStorage
    if (!serializedState) return undefined;
    return JSON.parse(serializedState);
  } catch {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    sessionStorage.setItem(STORAGE_KEY, serializedState); // use sessionStorage
  } catch {}
};

export const clearState = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {}
};
